import { createSlice } from '@reduxjs/toolkit'
import retrieveTitles from './titlesThunk'

const defaultActiveSort = 'LAST_ADDED'

const initialState = {
  pageNumber: 0,
  summaries: {},
  sortBy: ['LAST_ADDED', 'LAST_UPDATED', 'NAME', 'Name_TRANSLATED'],
  activeSort: defaultActiveSort,
  value: [],
  loading: false,
}

const titlesSlice = createSlice({
  name: 'titles',
  initialState,

  extraReducers: {
    [retrieveTitles.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveTitles.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.value = payload
    },
  },
})

export const selectTitles = ({ titles }) => titles
export const { activeSummaryHandler } = titlesSlice.actions

export default titlesSlice.reducer
